<template>
  <div>
    <b-table striped small hover :items="phonolEnvsData">
      <template #cell(action)="data">
        <div class="text-right">
          <router-link :to="{ name: 'PhonolEnvDetails', params: {
            id: data.item.id
          }}">
            <b-icon icon="link45deg"></b-icon>
          </router-link>
          <a
            href="#"
            v-if="editMode"
            @click="editRow($event, data.item.action.phonolEnv)"
            ><b-icon icon="pencil"></b-icon
          ></a>
          <a href="#" v-if="editMode" @click="deleteRow($event, data.item.id)"><b-icon icon="trash"></b-icon></a>
        </div>
      </template>
      <template #cell(id)="data">
        <tdColUUID :value="data.item.id" />
      </template>
    </b-table>
    <b-col sm="4" md="3" v-if="showTotalLable">
      Total {{ phonolEnvsData.length }} {{ phonolEnvsData.length === 1 ? 'entry' : "entries" }} in table
    </b-col>
  </div>
</template>

<style scoped>
  * >>> th {
    font-size: 10px !important;
    text-transform: uppercase;
    color: #bbbbbb;
  }
</style>

<script>
  import tdColUUID from '@/components/tdColUUID.vue'

  export default {
    name: 'PhonolEnvTable',
    props: ['phonolEnvs', 'editMode', 'showTotal'],
    data(){
      return {
        showTotalLable: this.showTotal ? this.showTotal : false
      }
    },
    components: {
      tdColUUID
    },
    computed: {
      phonolEnvsData(){
        return this.phonolEnvs.map((phonolEnv, index) => {
          phonolEnv['_index'] = index;
          return {
            id: phonolEnv.id,
            form: phonolEnv.form,
            comment: phonolEnv.comment,
            ordering: phonolEnv.ordering,
            action: {
              phonolEnv: phonolEnv
            },
          }
        }).sort((a, b) => {
          if (a.ordering < b.ordering) return -1;
          if (a.ordering > b.ordering) return 1;
          return 0;
        })
      }
    },
    methods: {
      deleteRow(event, id){
        event.preventDefault()
        this.$emit('delete', id)
      },
      editRow(event, phonolEnv) {
        event.preventDefault();
        this.$emit("edit", phonolEnv);
      },
    }
  }
</script>
